var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "column flex-grow-1" },
        [
          _c("h4", { staticClass: "mt-3" }, [_vm._v("Configuration")]),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "configuration enable",
              attrs: { "label-cols": "auto", label: "Enable Clyde" },
            },
            [
              _c("b-form-checkbox", {
                attrs: { switch: "" },
                on: {
                  change: function ($event) {
                    return _vm.patchClydeConfig()
                  },
                },
                model: {
                  value: _vm.clydeEnabled,
                  callback: function ($$v) {
                    _vm.clydeEnabled = $$v
                  },
                  expression: "clydeEnabled",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "configuration enable ml-2",
              attrs: {
                "label-cols": "auto",
                label: "Use Clyde as Registration Integration",
              },
            },
            [
              _c("b-form-checkbox", {
                attrs: { switch: "", disabled: !_vm.clydeEnabled },
                on: {
                  change: function ($event) {
                    return _vm.patchClydeConfig()
                  },
                },
                model: {
                  value: _vm.clydeRegistration,
                  callback: function ($$v) {
                    _vm.clydeRegistration = $$v
                  },
                  expression: "clydeRegistration",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { staticClass: "ml-2", attrs: { label: "Base URL for Clyde" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", disabled: !_vm.clydeEnabled },
                on: {
                  blur: function ($event) {
                    return _vm.patchClydeConfig()
                  },
                },
                model: {
                  value: _vm.clydeBaseUrl,
                  callback: function ($$v) {
                    _vm.clydeBaseUrl = $$v
                  },
                  expression: "clydeBaseUrl",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "ml-2",
              attrs: { label: "Button text for Log In Button" },
            },
            [
              _c("b-form-input", {
                attrs: { type: "text", disabled: !_vm.clydeEnabled },
                on: {
                  blur: function ($event) {
                    return _vm.patchClydeConfig()
                  },
                },
                model: {
                  value: _vm.clydeButtonText,
                  callback: function ($$v) {
                    _vm.clydeButtonText = $$v
                  },
                  expression: "clydeButtonText",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "ml-2",
              attrs: { label: "Link text for Log In Page" },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("span", { staticClass: "basis-14" }, [
                    _vm._v("You can also log in with"),
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: {
                      type: "text",
                      disabled: !_vm.clydeEnabled,
                      inline: "",
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.patchClydeConfig()
                      },
                    },
                    model: {
                      value: _vm.clydeLinkText,
                      callback: function ($$v) {
                        _vm.clydeLinkText = $$v
                      },
                      expression: "clydeLinkText",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }